module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/airplay-video-7d0b767f456d7597a279fdf12b921735.svg";